import { createContext } from "react";
import { observer } from "mobx-react-lite";

export const ModalContext = createContext<HTMLDialogElement | null>(null);

export const ModalContextProvider = observer<any>(({ children, dialog }: { children: any, dialog: HTMLDialogElement | null }) => (
    <ModalContext.Provider value={dialog}>{children}</ModalContext.Provider>
));
